import { courseRoles, type CourseRoleId } from '~/data/courseRoles'

export function getReadableJobEmploymentType(jobMode: string): string | undefined {
  return getReadableEnum(jobMode)
}

export function getReadableJobWorkMode(workMode: string): string | undefined {
  return getReadableEnum(workMode)
}

export function getReadableJobLocation(location: string | undefined): string | undefined {
  if (!location) {
    return undefined
  }
  let areaDisplay = location.split('|').map(getReadableEnum).join(', ')
  if (areaDisplay.endsWith('Hong Kong') || areaDisplay.endsWith('Macao')) {
    areaDisplay = areaDisplay.concat(', China')
  }
  return areaDisplay
}

export function getReadableJobIndustry(industry: string): string | undefined {
  return getReadableEnum(industry)
}

export function getReadableJobRole(roleId: CourseRoleId): string | undefined {
  return courseRoles.find((role) => role.id === roleId)?.title
}

export function getJobPageUrl(jobId: string, title?: string): string {
  return `/jobs/${jobId}---${toTitleSlug(title || '')}`
}
